/**
 * Outcome al usar técnica en learning (normativa 2026-08-08).
 * Reducción provisional: multiplier = 0.5 + 0.5 * p
 */

/**
 * @param {number} earned
 * @param {number} required
 * @param {{ random?: () => number }} [opts] — random in [0,1); injectable for tests
 * @returns {{ kind: 'full'|'fail'|'reduced', progress: number, effectMultiplier: number }}
 */
export function resolveLearningOutcome(earned, required, opts = {}) {
  const req = Number(required) || 0
  const earn = Math.max(0, Number(earned) || 0)

  if (req <= 0) {
    return { kind: 'full', progress: 1, effectMultiplier: 1 }
  }

  const p = earn / req
  if (p >= 1) {
    return { kind: 'full', progress: p, effectMultiplier: 1 }
  }

  const rand = typeof opts.random === 'function' ? opts.random() : Math.random()

  if (p < 0.3) {
    return { kind: 'fail', progress: p, effectMultiplier: 0 }
  }

  if (p < 0.4) {
    if (rand < 0.5) {
      return { kind: 'fail', progress: p, effectMultiplier: 0 }
    }
    const multiplier = 0.5 + 0.5 * p
    return { kind: 'reduced', progress: p, effectMultiplier: multiplier }
  }

  return {
    kind: 'reduced',
    progress: p,
    effectMultiplier: 0.5 + 0.5 * p,
  }
}
